// extracted by mini-css-extract-plugin
export default {"itemPhotoSelectDropdown":"iDUc0GAsZYV8EYuxoJDY","itemPhotoSelect":"mRpViXjX3ebqNxvzJLK1"};